import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import * as AuthActions from '../../auth/AuthActions';
import UserAvatar from '../UserAvatar';
import { canViewRoute } from '../../routes';
import './nav-sidebar.less';

@connect(
    state => ({
        user: state.auth.user,
        isFgUser: state.auth.user && state.auth.user.organisationName == 'Fergus',
        sidebarMainColour: state.theme.selected.sidebarMain.value,
        sidebarMainTextColour: state.theme.selected.sidebarMain.text,
        sidebarSecondaryColour: state.theme.selected.sidebarSecondary.value,
        sidebarSecondaryTextColour: state.theme.selected.sidebarSecondary.text,
        isOpen: state.sidebar.isOpen
    }),
    {...AuthActions}
)
export default class NavSidebar extends Component {
    handleLogout(e) {
        e.preventDefault();
        this.props.logout();
    }

    render() {
        var { user, sidebarMainColour, sidebarMainTextColour, sidebarSecondaryColour, sidebarSecondaryTextColour, width, sidebarUlHeight } = this.props;

        var topLinks = [
            {url: '/', icon: 'fa fa-tachometer', name: 'Dashboard'},
            {url: '/clients', icon: 'fa fa-users', name: 'Clients'},
            {url: '/discounts', icon: 'fa fa-tag', name: 'Discounts', guarded: true},
            {url: '/fergus-logs', icon: 'fa fa-history', name: 'Fergus Logs'},
        ]
        .filter(link => ! link.guarded || canViewRoute(link.url, user))
        .map((link) =>
            <SidebarLink
                key={link.url}
                {...link}
                backgroundColor={sidebarSecondaryColour}
                textColour={sidebarSecondaryTextColour}
            />
        );

        var bottomLinks = [
                {url: '/team', icon: 'fa fa-users', name: 'Users'},
                {url: '/settings', icon: 'fa fa-cog', name: 'Settings'},
            ]
            .filter(link => canViewRoute(link.url, user))
            .map(link =>
                <SidebarLink
                    key={link.url}
                    {...link}
                    backgroundColor={sidebarSecondaryColour}
                    textColour={sidebarSecondaryTextColour}
                />
            );

        var ulStyle = {};
        if(sidebarUlHeight) {
            ulStyle = {
                height: sidebarUlHeight,
                overflowY: 'auto'
            };
        }
        return (
            <div>
                <div id="nav-sidebar" className={"sidebar mm-menu mm-horizontal mm-current mm-opened"} style={{background: sidebarMainColour, color: sidebarMainTextColour, width}}>
                    <div className="user-display" style={{background: sidebarMainColour, color: sidebarMainTextColour}}>
                        <UserAvatar user={this.props.user} size={50} />
                        <span>{`${user.firstName} ${user.lastName}`}</span>
                    </div>
                    <div className="sidebar-menu">
                        <ul className="nav nav-sidebar" style={ulStyle}>
                            {topLinks}
                            {bottomLinks}
                            <li>
                                <a href="/logout" style={{color: sidebarMainTextColour}}>
                                    <i className="fa fa-sign-out"></i>
                                    <span className="text"> Logout</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

@connect(
    state => ({
        location: state.routing.locationBeforeTransitions,
    })
)
class SidebarLink extends React.Component {
    getLinkClassName(url) {
        return url == this.props.location.pathname ? 'active' : '';
    }
    render() {
        var {url, name, icon, backgroundColor, textColour} = this.props;
        return (
            <li style={{backgroundColor}} className={this.getLinkClassName(url)}>
                <Link to={url} style={{color: textColour}}>
                    <i className={icon}></i>
                    <span className="text"> {name} </span>
                </Link>
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/nav-sidebar/NavSidebar.js